<router-outlet></router-outlet>

<p-toast></p-toast>

<div id="loading">

    <p-progressSpinner></p-progressSpinner>

</div>
